// extracted by mini-css-extract-plugin
export default {"wrapper":"expanded_wrapper__EXarX","trigger":"expanded_trigger__SBcS8","content":"expanded_content__HdKyg"};